import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { JourneyEvent } from "../../../api/analyticsAdmin";
import { EventProperties } from "./EventProperties";

export const RawEventList: React.FC<{ events: JourneyEvent[] }> = ({ events }) => {
  const [expandedUuid, setExpandedUuid] = useState<string | null>(null);

  return (
    <ol className="flex flex-col divide-y divide-gray-100">
      {events.map((event) => {
        const isOpen = expandedUuid === event.uuid;
        return (
          <li key={event.uuid} className="py-2">
            <button
              onClick={() => setExpandedUuid(isOpen ? null : event.uuid)}
              className="w-full text-left flex items-baseline justify-between gap-3"
            >
              <span className="font-mono text-xs text-gray-700">{event.event}</span>
              <span className="text-xs text-gray-400 whitespace-nowrap">
                {format(parseISO(event.timestamp), "yyyy-MM-dd HH:mm:ss")}
              </span>
            </button>
            {isOpen && (
              <div className="mt-2 bg-gray-50 rounded-lg p-3">
                <EventProperties propertiesJson={event.propertiesJson} />
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
};
